import { makeVar } from '@apollo/client';


export const authDataVar = makeVar([]);
